// extracted by mini-css-extract-plugin
export var content = "ProfileCompletionModal-module--content--4f791";
export var submitButton = "ProfileCompletionModal-module--submitButton--d420f";